import { createSelector } from 'reselect';

const propsSelector = (state, props) => props;
const stateSelector = (state) => state;

export const subselectCreator = (rootSelector) => (subselector = (s) => s) =>
  createSelector([rootSelector, propsSelector, stateSelector], (rootState, props, state) =>
    subselector(rootState, props, state),
  );
